/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './study.reducer';

export const StudyDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const studyEntity = useAppSelector(state => state.study.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="studyDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.study.detail.title">Study</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.study.id">Id</Translate>
            </span>
          </dt>
          <dd>{studyEntity.id}</dd>
          <dt>
            <span id="studyId">
              <Translate contentKey="tinyMedicRestApp.study.studyId">Study Id</Translate>
            </span>
          </dt>
          <dd>{studyEntity.studyId}</dd>
          <dt>
            <span id="studyDescription">
              <Translate contentKey="tinyMedicRestApp.study.studyDescription">Study Description</Translate>
            </span>
          </dt>
          <dd>{studyEntity.studyDescription}</dd>
          <dt>
            <span id="studyInstanceUid">
              <Translate contentKey="tinyMedicRestApp.study.studyInstanceUid">Study Instance Uid</Translate>
            </span>
          </dt>
          <dd>{studyEntity.studyInstanceUid}</dd>
          <dt>
            <span id="accessionNumber">
              <Translate contentKey="tinyMedicRestApp.study.accessionNumber">Accession Number</Translate>
            </span>
          </dt>
          <dd>{studyEntity.accessionNumber}</dd>
          <dt>
            <span id="studyDateTime">
              <Translate contentKey="tinyMedicRestApp.study.studyDateTime">Study Date Time</Translate>
            </span>
          </dt>
          <dd>
            {studyEntity.studyDateTime ? <TextFormat value={studyEntity.studyDateTime} type="date" format={APP_DATE_FORMAT} /> : null}
          </dd>
          <dt>
            <span id="referringPhysicianName">
              <Translate contentKey="tinyMedicRestApp.study.referringPhysicianName">Referring Physician Name</Translate>
            </span>
          </dt>
          <dd>{studyEntity.referringPhysicianName}</dd>
          <dt>
            <span id="additionalPatientHistory">
              <Translate contentKey="tinyMedicRestApp.study.additionalPatientHistory">Additional Patient History</Translate>
            </span>
          </dt>
          <dd>{studyEntity.additionalPatientHistory}</dd>
          <dt>
            <span id="admittingDiagnosesDescription">
              <Translate contentKey="tinyMedicRestApp.study.admittingDiagnosesDescription">Admitting Diagnoses Description</Translate>
            </span>
          </dt>
          <dd>{studyEntity.admittingDiagnosesDescription}</dd>
          <dt>
            <span id="studyStatusId">
              <Translate contentKey="tinyMedicRestApp.study.studyStatusId">Study Status Id</Translate>
            </span>
          </dt>
          <dd>{studyEntity.studyStatusId}</dd>
          <dt>
            <span id="studyPriorityId">
              <Translate contentKey="tinyMedicRestApp.study.studyPriorityId">Study Priority Id</Translate>
            </span>
          </dt>
          <dd>{studyEntity.studyPriorityId}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.study.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{studyEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.study.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{studyEntity.timestampentry}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.study.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{studyEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.study.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{studyEntity.cursor}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.study.active">Active</Translate>
            </span>
          </dt>
          <dd>{studyEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="statusCode">
              <Translate contentKey="tinyMedicRestApp.study.statusCode">Status Code</Translate>
            </span>
          </dt>
          <dd>{studyEntity.statusCode}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.study.patient">Patient</Translate>
          </dt>
          <dd>{studyEntity.patient ? studyEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.study.rStudy">R Study</Translate>
          </dt>
          <dd>{studyEntity.rStudy ? studyEntity.rStudy.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/study" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/study/${studyEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default StudyDetail;
